import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import ProgramConnectTable from "./ProgramConnectTable";
import useProgramConnect from "./useProgramConnect";

const defaultData = {
};

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  }
});

const ProgramConnect = ({ disabled, quizId, classes, editmode }) => {
  const { connectsData, getConnects } = useProgramConnect();

  useEffect((quizId) => {
    getConnects(quizId);
  }, [quizId]);

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Подключение к программам, модулям и курсам</Typography>
      <ProgramConnectTable connectsData={connectsData}
                    getConnects={getConnects}/>
    </div>
  );
};

export default withStyles(styles)(ProgramConnect);
